module.exports = __webpack_public_path__ + "img/zakuJack.60a090c4.png";